var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":require("@/assets/librototal.png"),"width":"100%"},on:{"click":_vm.getContents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }